module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADBSURBVEhL7ZDRDcIwDEQj9Z8ZugarwBYsAMOwCqzBDPyjFF/yAJUoaSA/COVJlWX77hzVdb7Ge7+ZKpEWWx3mGc10jfZl0I7Yy5hwMMMJ482+nar6EngGYvKYcB8tgYNmqrEtI28IyWGC9eO1Vs9WwotU6YvIq4wQ9o4tVvZdECb/VD3zIspQFrYXNjyikWjLeIbmSIooC8sc9hPtx2DP+9n/0QHaJ4wX57Qp7PuB9gM5kP3AgVaIS2HfDHGdGpy7AxWyUl68Q3WhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-house/light/24.png
// module id = 2162
// module chunks = 2